// src/api/assessment.api.js
import api from './axios';

export const getUserAssessment = (userId) =>
  api.get(`/ShapeUpAssessment/${userId}`);
